<template>
  <div id="tags-view-container" class="tags-view-container">
    <scroll-pane ref="scrollPane" class="tags-view-wrapper" @scroll="handleScroll">
      <router-link
        v-for="tag in visitedViews"
        :key="tag.path"
        ref="tag"
        v-slot="{ navigate }"
        :data-path="tag.path"
        class="tags-view-item"
        :class="isActive(tag) ? 'active' : ''"
        :to="{ path: tag.path, query: tag.query, fullPath: tag.fullPath }"
        custom
      >
        <span role="link" @click="navigate">
          {{ tag.title }}
          <span v-if="!isAffix(tag)" class="el-icon-close" @click.prevent.stop="closeSelectedTag(tag)" />
        </span>
      </router-link>
      <!-- <router-link
        v-for="tag in visitedViews"
        ref="tag"
        :key="tag.path"
        :class="isActive(tag)?'active':''"
        :to="{ path: tag.path, query: tag.query, fullPath: tag.fullPath }"
        tag="span"
        class="tags-view-item"
        @click.middle.native="!isAffix(tag)?closeSelectedTag(tag):''"
        @contextmenu.prevent.native="openMenu(tag,$event)"
      >
        {{ tag.title }}
        <span v-if="!isAffix(tag)" class="el-icon-close" @click.prevent.stop="closeSelectedTag(tag)" />
      </router-link> -->
    </scroll-pane>
    <ul v-show="visible" :style="{left:left+'px',top:top+'px'}" class="contextmenu">
      <li @click="refreshSelectedTag(selectedTag)">Refresh</li>
      <li v-if="!isAffix(selectedTag)" @click="closeSelectedTag(selectedTag)">Close</li>
      <li @click="closeOthersTags">Close Others</li>
      <li @click="closeAllTags(selectedTag)">Close All</li>
    </ul>
  </div>
</template>

<script>
import ScrollPane from './ScrollPane'
import path from 'path'

export default {
  components: { ScrollPane },
  data() {
    return {
      visible: false,
      top: 0,
      left: 0,
      selectedTag: {},
      affixTags: []
    }
  },
  computed: {
    visitedViews() {
      return this.$store.state.tagsView.visitedViews
    },
    routes() {
      return this.$store.state.permission.routes
    }
  },
  watch: {
    $route() {
      this.addTags()
      this.moveToCurrentTag()
    },
    visible(value) {
      if (value) {
        document.body.addEventListener('click', this.closeMenu)
      } else {
        document.body.removeEventListener('click', this.closeMenu)
      }
    }
  },
  mounted() {
    this.initTags()
    this.addTags()
  },
  methods: {
    isActive(route) {
      return route.path === this.$route.path
    },
    isAffix(tag) {
      return tag.meta && tag.meta.affix
    },
    filterAffixTags(routes, basePath = '/') {
      let tags = []
      routes.forEach(route => {
        if (route.meta && route.meta.affix) {
          const tagPath = path.resolve(basePath, route.path)
          tags.push({
            fullPath: tagPath,
            path: tagPath,
            name: route.name,
            meta: { ...route.meta }
          })
        }
        if (route.children) {
          const tempTags = this.filterAffixTags(route.children, route.path)
          if (tempTags.length >= 1) {
            tags = [...tags, ...tempTags]
          }
        }
      })
      return tags
    },
    initTags() {
      const affixTags = this.affixTags = this.filterAffixTags(this.routes)
      for (const tag of affixTags) {
        // Must have tag name
        if (tag.name) {
          this.$store.dispatch('tagsView/addVisitedView', tag)
        }
      }
    },
    addTags() {
      const { name } = this.$route
      if (name) {
        this.$store.dispatch('tagsView/addView', this.$route)
      }
      return false
    },
    moveToCurrentTag() {
      const tags = this.$refs.tag
      this.$nextTick(() => {
        for (const tag of tags) {
          if (tag.to.path === this.$route.path) {
            this.$refs.scrollPane.moveToTarget(tag)
            // when query is different then update
            if (tag.to.fullPath !== this.$route.fullPath) {
              this.$store.dispatch('tagsView/updateVisitedView', this.$route)
            }
            break
          }
        }
      })
    },
    refreshSelectedTag(view) {
      this.$store.dispatch('tagsView/delCachedView', view).then(() => {
        const { fullPath } = view
        this.$nextTick(() => {
          this.$router.replace({
            path: '/redirect' + fullPath
          })
        })
      })
    },
    closeSelectedTag(view) {
      this.$store.dispatch('tagsView/delView', view).then(({ visitedViews }) => {
        if (this.isActive(view)) {
          this.toLastView(visitedViews, view)
        }
      })
    },
    closeOthersTags() {
      this.$router.push(this.selectedTag)
      this.$store.dispatch('tagsView/delOthersViews', this.selectedTag).then(() => {
        this.moveToCurrentTag()
      })
    },
    closeAllTags(view) {
      this.$store.dispatch('tagsView/delAllViews').then(({ visitedViews }) => {
        if (this.affixTags.some(tag => tag.path === view.path)) {
          return
        }
        this.toLastView(visitedViews, view)
      })
    },
    toLastView(visitedViews, view) {
      const latestView = visitedViews.slice(-1)[0]
      if (latestView) {
        this.$router.push(latestView.fullPath)
      } else {
        // now the default is to redirect to the home page if there is no tags-view,
        // you can adjust it according to your needs.
        if (view.name === 'Dashboard') {
          // to reload home page
          this.$router.replace({ path: '/redirect' + view.fullPath })
        } else {
          this.$router.push('/')
        }
      }
    },
    openMenu(tag, e) {
      const menuMinWidth = 105
      const offsetLeft = this.$el.getBoundingClientRect().left // container margin left
      const offsetWidth = this.$el.offsetWidth // container width
      const maxLeft = offsetWidth - menuMinWidth // left boundary
      const left = e.clientX - offsetLeft + 15 // 15: margin right

      if (left > maxLeft) {
        this.left = maxLeft
      } else {
        this.left = left
      }

      this.top = e.clientY
      this.visible = true
      this.selectedTag = tag
    },
    closeMenu() {
      this.visible = false
    },
    handleScroll() {
      this.closeMenu()
    }
  }
}
</script>

<style lang="scss" scoped>
.tags-view-container {
  height: 34px;
  width: 100%;
  background: #fff;
  // border-bottom: 1px solid #d8dce5;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, .12), 0 0 3px 0 rgba(0, 0, 0, .04);
  .tags-view-wrapper::v-deep {
    .el-scrollbar__view {
      padding: 0 15px;
      height: 34px;
      display: flex;
      align-items: flex-end;

      .tags-view-item {
        position: relative;
        display: inline-flex;
        align-items: center;
        justify-content: space-between;
        height: 26px;
        line-height: 26px;
        padding: 0 8px;
        margin: 0 -15px;
        border-radius: 2px;
        border-style: solid;
        border-color: transparent;
        border-width: 15px 27px 15px;
        color: #495060;
        background: #fff;
        font-size: 12px;
        z-index: 0;
        transition: all .3s cubic-bezier(.2,1,.3,1);
        cursor: pointer;

        &::before {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          opacity: 0;
          z-index: -1;
          content: '';
          background: #0256FF;
        }

        &.active {
          background: #e5eeff;
          color: #0256FF;
          font-weight: 600;
          z-index: 1;
          mask-image: url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNzAiIGhlaWdodD0iNzAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgZmlsbD0ibm9uZSI+PHBhdGggZD0iTTEwMC4yMzYgOTkuODgzQzQ1LjAwOCAxMDAuMDEyLjEzMiA1NS4zNDQuMDAzLjExN2wuMjMzIDEwMCAxMDAtLjIzNHoiIG9wYWNpdHk9InVuZGVmaW5lZCIgc3Ryb2tlPSJudWxsIiBmaWxsPSIjRjhFQUU3Ii8+PHBhdGggZD0iTS0uNjM4IDcuMzEyYy4xMiAwIC4yMTguMDU4LjQ3Ny4xMi4yMzIuMDU0LjI3My4wMzQuMzU4LjExOS4wODQuMDg0LjM1NyAwIC40NzYgMGguMzU4TTI4LjkyMSA2OS4wNTJ2LjU5Nk0yOC45MjEgNjguNDU3aC4xMTl2MS43ODhoLS4xMTl6TTM2LjY2OSA1MS4yOTNoMTkuMDd2NC44ODdoLTE5LjA3eiIgc3Ryb2tlPSJudWxsIi8+PC9zdmc+"),url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNzAiIGhlaWdodD0iNzAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgZmlsbD0ibm9uZSI+PHBhdGggc3Ryb2tlPSJudWxsIiBmaWxsPSIjRjhFQUU3IiBkPSJNNjkuOTU0LjE0Yy0uMjI5IDU1LjIyOC00NS4xODYgOTkuODE0LTEwMC40MTMgOTkuNTg1bDk5Ljk5OS40MTRMNjkuOTU0LjE0eiIgY2xpcC1ydWxlPSJldmVub2RkIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz48cGF0aCBkPSJNLS42MzggNy4zMTJjLjEyIDAgLjIxOC4wNTguNDc3LjEyLjIzMi4wNTQuMjczLjAzNC4zNTguMTE5LjA4NC4wODQuMzU3IDAgLjQ3NiAwaC4zNThNMjguOTIxIDY5LjA1MnYuNTk2TTI4LjkyMSA2OC40NTdoLjExOXYxLjc4OGgtLjExOXpNMzYuNjY5IDUxLjI5M2gxOS4wN3Y0Ljg4N2gtMTkuMDd6IiBzdHJva2U9Im51bGwiLz48L3N2Zz4="),url('data:image/svg+xml;charset=utf-8,<svg xmlns="http://www.w3.org/2000/svg"><rect rx="8" width="100%" height="100%" fill="%23F8EAE7"/></svg>');
          mask-size: 18px 30px,20px 30px,calc(100% - 30px) calc(100% + 17px);
          mask-position: right bottom,left bottom,center top;
          mask-repeat: no-repeat;

          &::before {
            opacity: 1;
            border-radius: 3px;
            transform: translateZ(0);
          }
        }
        .el-icon-close {
          margin-left: 5px;
        }
      }
      // .tags-view-item {
      //   display: inline-block;
      //   position: relative;
      //   cursor: pointer;
      //   height: 26px;
      //   line-height: 26px;
      //   border: 1px solid #d8dce5;
      //   color: #495060;
      //   background: #fff;
      //   padding: 0 8px;
      //   font-size: 12px;
      //   margin-left: 5px;
      //   margin-top: 4px;
      //   &:first-of-type {
      //     margin-left: 15px;
      //   }
      //   &:last-of-type {
      //     margin-right: 15px;
      //   }
      //   &.active {
      //     background-color: #42b983;
      //     color: #fff;
      //     border-color: #42b983;
      //     &::before {
      //       content: '';
      //       background: #fff;
      //       display: inline-block;
      //       width: 8px;
      //       height: 8px;
      //       border-radius: 50%;
      //       position: relative;
      //       margin-right: 2px;
      //     }
      //   }
      // }
    }
  }
  .contextmenu {
    margin: 0;
    background: #fff;
    z-index: 3000;
    position: absolute;
    list-style-type: none;
    padding: 5px 0;
    border-radius: 4px;
    font-size: 12px;
    font-weight: 400;
    color: #333;
    box-shadow: 2px 2px 3px 0 rgba(0, 0, 0, .3);
    li {
      margin: 0;
      padding: 7px 16px;
      cursor: pointer;
      &:hover {
        background: #eee;
      }
    }
  }
}
</style>

<!--
<style lang="scss">
//reset element css of el-icon-close
.tags-view-wrapper {
  .tags-view-item {
    .el-icon-close {
      width: 16px;
      height: 16px;
      vertical-align: 2px;
      border-radius: 50%;
      text-align: center;
      transition: all .3s cubic-bezier(.645, .045, .355, 1);
      transform-origin: 100% 50%;
      &:before {
        transform: scale(.6);
        display: inline-block;
        vertical-align: -3px;
      }
      &:hover {
        background-color: #b4bccc;
        color: #fff;
      }
    }
  }
}
</style>
-->
